import * as React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../../actions'
import LoginModal from '../../molecules/login-modal'
import routes from '../../../routes'
import * as H from 'history'

type ApplicationProps = {
  loadDasher: () => Promise<any>
  applicantUniqueLink: string
  history: H.History
}

export const Application: React.FC<ApplicationProps> = ({
  loadDasher,
  applicantUniqueLink,
  history,
}) => {
  React.useEffect(() => {
    loadDasher()
  }, [])

  if (history && applicantUniqueLink) {
    history.push(routes.application.path + applicantUniqueLink)
  }
  return <LoginModal shouldHideDescription />
}
const mapStateToProps = state => {
  return {
    applicantUniqueLink: state.applicantUniqueLink,
  }
}

const mapDispatchToProps = {
  loadDasher: actions.loadDasher,
}

export default connect(mapStateToProps, mapDispatchToProps)(Application)
